import { Button, Classes, Dialog, Intent, Switch } from '@blueprintjs/core'
import React from 'react'
import { setInStorage, getFromStorage } from '../../../storage'
import { isCustomizableColumn, visibleCustomizableColumnCount } from './Constants'

interface Props {
  isOpen: any
  columns: any
  onDialogClose: any
  onEnabledColumnChange: any
  storageKey: any
  // passed by the listing_manager index consumers; this dialog computes its own
  // eslint-disable-next-line react/no-unused-prop-types
  enabledColumns?: any
}
export default ({ isOpen, columns, onDialogClose, onEnabledColumnChange, storageKey }: Props) => {
  const visibleCount = visibleCustomizableColumnCount(columns)

  return (
    <Dialog isOpen={isOpen} onClose={onDialogClose} title="Customize Columns">
      <div className={Classes.DIALOG_BODY} style={{ maxHeight: 350, overflowY: 'scroll' }}>
        <table className="bp5-compact" style={{ width: '100%', maxWidth: '300px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left' }}>Column</th>
              <th style={{ textAlign: 'left' }}>Show Column</th>
            </tr>
          </thead>
          <tbody>
            {columns.map(c => {
              if (!isCustomizableColumn(c)) return null
              const name = c.Header || (c.id === 'thumb' ? 'Thumbnail' : null)
              const isLastVisible = c.show !== false && visibleCount <= 1
              return (
                <tr key={c.id}>
                  <td>{name}</td>
                  <td>
                    <Switch
                      checked={c.show}
                      disabled={isLastVisible}
                      onChange={e => {
                        const { checked } = e.currentTarget
                        if (!checked && visibleCustomizableColumnCount(columns) <= 1) return
                        const item = getFromStorage(storageKey, true) || {}
                        const enabledColumns = { ...item, [c.id]: checked }
                        setInStorage(storageKey, enabledColumns, true)
                        onEnabledColumnChange(enabledColumns)
                      }}
                    />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <ul />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button intent={Intent.PRIMARY} onClick={onDialogClose}>
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
